import colors from '@/config/colors';
import { Dimensions, StyleSheet } from 'react-native';
const width = Dimensions.get('window').width;

export const styles = StyleSheet.create({
  secondHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.grey,
    padding: 10,
    borderBottomColor: '#aaaa',
    borderBottomWidth: 1,
  },
  input: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    width: width / 3.5,
  },
  textInput: {
    width: '90%',
    marginTop: 4,
    fontSize: 16,
    marginBottom: 4,
    color: colors.newUI.therapist.textBlue100,
  },
  closeButtonParent: {
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 5,
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 3,
  },
  marginRight: {
    marginRight: 7.5,
  },
  secondHeaderTitle: {
    fontSize: 18,
    color: colors.darkGrey,
    fontWeight: '700',
  },
  dropDownContainer: {
    position: 'relative',
    zIndex: 1,
    width: width / 3.5,
  },
});
